import { useModal } from '@features/Shared/Modal/_js/modal';

export function useSeedEyeLicenseActivationPage(): void {
  const { showModal, setModalContent } = useModal();

  // Open modal
  document.querySelectorAll('.seed-eye-license-activation-page__open-modal').forEach((element) => {
    element.addEventListener('click', () => {
      showModal('modal-seed-eye-license-activation-page').then(() => {
        let template: string = document.getElementById('terms-modal')?.innerHTML as string;

        setModalContent(template);
      });
    });
  });

  document.getElementById('VerifyEmail')?.addEventListener('blur', (event) => {
    const emailInput = document.getElementById('EmailAddress') as HTMLInputElement;
    const verifyEmailInput = event.target as HTMLInputElement;

    const email = emailInput?.value;
    const validationEmail = verifyEmailInput?.value;

    if (email !== validationEmail) {
      verifyEmailInput.setCustomValidity("Email Address do not match");
    } else {
      verifyEmailInput.setCustomValidity("");
    }
  });
}

document.addEventListener('DOMContentLoaded', useSeedEyeLicenseActivationPage);